<template lang="pug">
v-autocomplete(
  @change='onSelect'
  @click:clear='clear'
  :items='suggestions'
  :loading='isLoading'
  :search-input.sync='search'
  :auto-select-one-item='false'
  :no-filter='true'
  :hide-selected='false'
  :hide-no-data='true'
  :return-object='true'
  :clearable='true'
  :label='label'
  :item-text='itemText'
  :item-value='itemValue'
  v-bind='$attrs'
  v-model='model'
)
</template>

<script>
import http from '@/http'
import { debounce } from 'lodash'

export default {
  props: {
    value: null,
    params: {
      default: () => ({})
    },
    label: {
      default: 'Введите текст для поиска'
    },
    itemText: {
      default: 'value'
    },
    itemValue: {
      default: 'value'
    },
    dataSource: {
      default: '/suggest/address'
    },
    skey: {
      default: 'search'
    },
    innerData: {
      default: false
    }
  },

  data: () => ({
    model: {},
    search: null,
    suggestions: [],
    isLoading: false
  }),

  mounted() {
    if (this.value && Object.keys(this.value).length) {
      this.model = this.value
      this.suggestions.push(this.model)
    }
  },

  methods: {
    async fetchSuggests(payload) {
      try {
        this.isLoading = true
        let params = Object.assign({ [this.skey]: payload }, this.params)
        this.suggestions = this.innerData ? (await http.get(this.dataSource, { params })).data.data : (await http.get(this.dataSource, { params })).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки списка')
      } finally {
        this.isLoading = false
      }
    },

    onSelect(suggestion = {}) {
      this.$emit('input', suggestion)
    },

    clear() {
      this.model = {}
      this.suggestions = []

      this.$nextTick(() => this.$emit('input', this.model))
    },

    debouncedFetchSuggests: debounce(function(query) {
      if (query && query.length > 3) {
        this.fetchSuggests(query)
      }
    }, 250)
  },

  watch: {
    search: 'debouncedFetchSuggests',

    value(value) {
      if (value && Object.keys(value).length) {
        this.model = value
        this.suggestions.push(this.model)
      } else {
        this.model = {}
        this.suggestions = []
      }
    }
  }
}
</script>
